import type { ExportConfig, GeneratedFile, LanguageGenerator } from './types';
import { generateEnv } from './utils';

export const clojureGenerator: LanguageGenerator = {
  id: 'clojure',
  name: 'Clojure',
  category: 'request-examples',
  color: '#5881D8',
  generate(config: ExportConfig): GeneratedFile[] {
    const fnBlocks = config.apps
      .flatMap((a) =>
        a.templates.map((t) => {
          const exampleData = t.schema
            ? t.schema.map((f) => `              :${f.key} ${f.type === 'number' ? (f.example || '0') : f.type === 'boolean' ? 'true' : `"${f.example || f.key}"`}`).join('\n')
            : '              ;; no schema';
          return [
            `(defn send-${t.camelName.replace(/([A-Z])/g, '-$1').toLowerCase()} [recipient]`,
            `  (http/post (str service-url "/v1/send")`,
            `             {:headers {"Content-Type" "application/json"`,
            `                        "X-API-KEY"    (System/getenv "${a.envVarName}")}`,
            `              :body (json/write-str`,
            `                      {:template_slug "${t.slug}"`,
            `                       :recipient      recipient`,
            `                       :data           {`,
            `${exampleData}`,
            `                                       }})}))`,
          ].join('\n');
        }),
      )
      .join('\n\n');

    const content = `; mail_requests.clj — generated by Mail Service SDK Export
; Requires: clj-http  {:deps {clj-http/clj-http {:mvn/version "3.12.3"}}}
(ns mail-requests
  (:require [clj-http.client :as http]
            [clojure.data.json :as json]))

(def service-url (System/getenv "${config.serviceUrlVarName}"))

${fnBlocks}

; Example usage:
; (send-${config.apps[0]?.templates[0]?.camelName?.replace(/([A-Z])/g, '-$1').toLowerCase() || 'template'} "user@example.com")
`;

    return [
      { filename: 'mail_requests.clj', content, syntax: 'clojure' },
      { filename: '.env', content: generateEnv(config), syntax: 'shell' },
    ];
  },
};
